import "./PhoneSelect.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { BsFillCaretDownFill } from "react-icons/bs";

// react-phone-input-2 знає per-країнний формат номера (напр. Україна
// "+... (..) ... .. ..", Іспанія "+.. ... ... ..."). Кількість крапок
// у форматі = довжина номера разом з кодом країни, тож звіряємо реальну
// кількість цифр з цим значенням замість власного списку країн.
const isPhoneValidForCountry = (value, country) => {
  if (!country?.format) return true; // бібліотека не має точного формату для цієї країни

  const digits = (value || "").replace(/\D/g, "");
  if (!digits || digits === country.dialCode) return true; // ще не введено жодної цифри номера

  const expectedLength = (country.format.match(/\./g) || []).length;

  return digits.length === expectedLength;
};

export default function PhoneSelect({
  addServiceModal,
  addClientPersonModal,
  newRegistrationForm,
  recordModal,
  autoServiceModal,
  registration,
  field,
  form,
  addDistrModal,
  staffModal,
  setIsSendCodeBtnDisabled,
  ...props
}) {
  // Модалі, де валідність номера (за форматом обраної країни) впливає на сабміт форми через Yup (див. this.parent.<field>_valid у відповідних схемах).
  const trackValidity =
    recordModal ||
    autoServiceModal ||
    addClientPersonModal ||
    addDistrModal ||
    staffModal;

  const handleChange = (value, country) => {
    form.setFieldValue(field.name, value);
    if (trackValidity) {
      form.setFieldValue(
        `${field.name}_valid`,
        isPhoneValidForCountry(value, country)
      );
    }
    registration &&
      setIsSendCodeBtnDisabled(!isPhoneValidForCountry(value, country));
  };

  return (
    <div className="phoneBox">
      <PhoneInput
        country={"ua"}
        value={field.value}
        isValid={trackValidity ? isPhoneValidForCountry : true}
        onChange={handleChange}
        placeholder="1234567"
        containerStyle={{
          display: "flex",
        }}
        buttonStyle={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "var(--bg-input)",
          borderColor: registration ? "transparent" : "var(--input-stroke)",
          ...(registration && {
            borderRight: " 1px solid var(--input-stroke)",
          }),
          borderRadius:
            addServiceModal || addClientPersonModal || autoServiceModal
              ? "4px 0 0 4px"
              : recordModal
                ? "6px 0 0 6px"
                : registration
                  ? "0"
                  : "10px 0 0 10px",
          ...(addServiceModal && {
            paddingLeft: "clamp(3px, min(0.463vh, 0.27vw), 5px)",
            maxHeight: "clamp(21px, min(2.963vh, 1.73vw) 32px)",
          }),
          width:
            addServiceModal || autoServiceModal
              ? "clamp(30px, min(4.167vh, 2.432vw), 45px)"
              : recordModal
                ? "clamp(36px, min(5.093vh, 2.973vw), 55px)"
                : "clamp(41px, min(5.556vh, 3.243vw), 60px)",
        }}
        inputStyle={{
          backgroundColor: "var(--bg-input)",
          color: registration ? "var(--white)" : "var(--light-gray)",
          border: registration ? "none" : "1px solid var(--input-stroke)",
          borderLeft: "none",
          borderRadius:
            addServiceModal || addClientPersonModal || autoServiceModal
              ? "4px"
              : recordModal
                ? "6px"
                : registration
                  ? "0"
                  : "10px",
          paddingLeft:
            addServiceModal || autoServiceModal
              ? "clamp(33px, min(4.444vh, 2.594vw), 48px)"
              : recordModal
                ? "clamp(39px, min(5.370vh, 3.135vw), 58px)"
                : "clamp(44px, min(3.514vw, 6.019vh), 65px)",

          fontSize: addServiceModal
            ? "clamp(10px, min(1.389vh, 0.811vw), 15px)"
            : registration
              ? " 14px"
              : "clamp(12px, min(1.481vh, 0.864vw), 16px)",
          fontWeight: 400,
          lineHeight: "normal",
          ...(registration && {
            paddingTop: "10px",
            paddingBottom: "10px",
            lineHeight: " 1.142em",
          }),
          height:
            addServiceModal || addClientPersonModal || autoServiceModal
              ? "clamp(22px, min(3.055vh, 1.784vw), 33px)"
              : recordModal
                ? "clamp(30px, min(4.26vh, 15.568vw / 6.261), 46px)"
                : registration
                  ? "unset"
                  : "clamp(36px, min(5.092vh, 2.973vw), 55px)",
          width: addServiceModal
            ? "clamp(135px, min(18.148vh, 10.595vw), 196px)"
            : addClientPersonModal || newRegistrationForm || autoServiceModal
              ? "100%"
              : recordModal
                ? "clamp(155px, min(21.481vh, 12.541vw), 232px)"
                : registration
                  ? ""
                  : "clamp(166px, min(22.222vh, 12.973vw), 240px)",
        }}
        dropdownStyle={{
          backgroundColor: "var(--bg-input)",
          marginTop: "8px",
          ...(addServiceModal && {
            bottom: "100%",
            top: "auto",
          }),
        }}
      />

      <BsFillCaretDownFill
        className={`arrowPhone ${
          addDistrModal
            ? "arrowDistrModal"
            : addServiceModal || autoServiceModal
              ? "arrowPhoneServiceModal"
              : // : addClientPersonModal
                registration
                ? "arrowRegistration"
                : ""
        }`}
      />
    </div>
  );
}
